import { render } from "./WCOrderTypeCollapseCard.vue?vue&type=template&id=07df96c0&scoped=true"
import script from "./WCOrderTypeCollapseCard.vue?vue&type=script&lang=js"
export * from "./WCOrderTypeCollapseCard.vue?vue&type=script&lang=js"

import "./WCOrderTypeCollapseCard.vue?vue&type=style&index=0&id=07df96c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07df96c0"]])

export default __exports__